import { render, staticRenderFns } from "./ImageObjUpload.vue?vue&type=template&id=ac63b806&scoped=true"
import script from "./ImageObjUpload.vue?vue&type=script&lang=js"
export * from "./ImageObjUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageObjUpload.vue?vue&type=style&index=0&id=ac63b806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac63b806",
  null
  
)

export default component.exports